module.exports = __webpack_public_path__ + "static/media/bgLinesCasino.9d1fc785.jpg";